import { render, staticRenderFns } from "./AsyncCase.vue?vue&type=template&id=45c39509&scoped=true&"
import script from "./AsyncCase.vue?vue&type=script&lang=js&"
export * from "./AsyncCase.vue?vue&type=script&lang=js&"
import style0 from "./AsyncCase.vue?vue&type=style&index=0&id=45c39509&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c39509",
  null
  
)

export default component.exports